import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../libs/shared/core/src/models/api/paletteModel';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {InfoBubble, InfoBubbleInstanceProps} from '../../../libs/shared/ui/src/components/tip/infoBubble';
import {InfoBubbleContent} from '../../../libs/shared/ui/src/components/tip/infoBubbleContent';
import {InfoBubbleDescription} from '../../../libs/shared/ui/src/components/tip/infoBubbleContentDescription';
import {InfoBubbleTitle} from '../../../libs/shared/ui/src/components/tip/infoBubbleContentTitle';
import {InfoBubbleFooterActions} from '../../../libs/shared/ui/src/components/tip/infoBubbleFooterActions';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import p3Image from '../../assets/images/bubbleTourP3.png';
import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {Image} from '../common/image';
import {useOnboardingInfoBubblePresenter} from './onboardingInfoBubbleHook';

/*
 * Component.
 */

export const P3InfoBubble: FC<InfoBubbleInstanceProps> = ({anchor}) => {
  const {isVisible, closeInfoBubble: onClose} = useOnboardingInfoBubblePresenter(OnboardingTipTypesEnum.P3);

  return (
    <InfoBubble
      position="left"
      anchor={anchor}
      interactionId="p3-conversation-view"
      isVisible={isVisible}
      isInteractive
      onRequestClose={onClose}
    >
      <InfoBubbleContent>
        <Image src={p3Image} width={648} height={392} />
        <InfoBubbleTitle>
          <Trans id="infobubble-p3-title">Where the messaging magic happens</Trans>
        </InfoBubbleTitle>
        <InfoBubbleDescription>
          <Trans id="infobubble-p3-description">
            Send and answer messages or exchange comments with your team.
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleFooterActions>
          <Button
            onClick={() => {
              onClose();
            }}
            size={VisualSizesEnum.MEDIUM}
            color={PaletteColorsEnum.PINK}
            variant={ButtonVariantsEnum.CUSTOM}
          >
            <Trans id="infobubble-p3-cta">Cool</Trans>
          </Button>
        </InfoBubbleFooterActions>
      </InfoBubbleContent>
    </InfoBubble>
  );
};
